// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useState} from 'react';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import styles from './period_slider.module.less';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';


interface i_switch_buttons_props {
    text: string;
    id: string;
    on_click: (id: string)=>void;
    is_active: boolean;
    is_lobby_page?: boolean;
}

const Switch_buttons = (props: i_switch_buttons_props)=>{
    const {text, id, on_click, is_active, is_lobby_page} = props;
    const {theme} = useContext(Settings_context);
    if (is_active)
    {
        return <Fragment>
          <Button
            caption={text} size="md" color="black"
            cls={cn(styles.period_button, is_lobby_page &&
              styles.period_button_lobby)}/>
        </Fragment>;
    }
    return <Fragment>
      <p
        className={cn(styles.text_option, theme.P, theme.p14, theme.med,
          theme.color_n600, is_lobby_page && styles.text_option_lobby)}
        onClick={()=>on_click(id)}>
          {text}
      </p>
    </Fragment>;
};

interface i_period_slider_props {
    is_lobby_page?: boolean;
}

export const Period_slider = (props: i_period_slider_props)=>{
    const {is_lobby_page} = props;
    const {qs, set_qs} = use_qs_with_set();
    const [selected_period, set_selected_period] = useState(qs.period || '1w');
    const handle_click = (id: string)=>{
        const period = id == 'weekly' ? undefined : '1m';
        set_selected_period(period || '1w');
        set_qs({period});
    };
    return <div className={cn(styles.slider_container,
      is_lobby_page && styles.slider_container_lobby)}>
      <Switch_buttons
        text="Weekly"
        id="weekly"
        is_active={selected_period == '1w'}
        on_click={handle_click}
        is_lobby_page={is_lobby_page}
      />
      <Switch_buttons
        text="Monthly"
        id="monthly"
        is_active={selected_period == '1m'}
        on_click={handle_click}
        is_lobby_page={is_lobby_page}
      />
    </div>;
};
